import { canonicalPrinting, printingIdentityToken } from "./printingIdentity";
import type { ScanIdentity } from "@/types/scan";

// Condition order is chosen by the caller; market price never selects an edition.
export function selectScanVariant(
  variants: Array<{ id: number; printing?: { name?: string | null } | null }>,
  identity?: ScanIdentity,
  setName?: string | null,
  catalogLanguage?: string | null,
): number | null {
  const isConfirmedScan = identity?.status === "exact_match" &&
    (identity.automaticAddEligible ?? identity.pricingEligible) && identity.language === "english";
  const shadowlessCatalog = setName?.toLowerCase().replace(/[^a-z]/g, "") === "basesetshadowless";
  if (isConfirmedScan && shadowlessCatalog) {
    const edition = identity.detectedBaseSetEdition;
    const printing = edition === "1st" ? "1st Edition" : edition === "shadowless" ? "Unlimited" : null;
    // Older scans without explicit edition evidence must not silently select 1st.
    return printing ? variants.find(v => v.printing?.name === printing)?.id ?? null : null;
  }
  const foreign = ["japanese", "chinese"].includes(catalogLanguage ?? identity?.language ?? "");
  const detected = canonicalPrinting(identity?.detectedPrinting);
  if (identity?.status === "exact_match" && detected) {
    return variants.find(v => canonicalPrinting(v.printing?.name) === detected)?.id ?? null;
  }
  if (foreign) {
    // A market value or array position is not evidence of the collector's finish.
    const known = variants.filter(v => printingIdentityToken(v.printing?.name));
    const finishes = new Set(known.map(v => printingIdentityToken(v.printing?.name)));
    if (finishes.size === 1) return known[0]?.id ?? null;
    if (finishes.size > 1) return null;
    return variants.find(v => !printingIdentityToken(v.printing?.name))?.id ?? null;
  }
  return variants[0]?.id ?? null;
}
